// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem_menuItem__28mFk","active":"MenuItem_active__2_ZpZ"};